// @flow

import Notifications from '../constants/Notifications';
import { Component } from '../jsti/core';
import Scroll from './Scroll';
import { isLargeScreen } from '../classes/Helpers';

export default class Header extends Component {
  scrolledClass: string = 'scrolled';
  searchClass: string = 'header--search';
  scrollTransitionInMilliseconds: number = 300;

  /**
   * Initiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.addListener(Notifications.SCROLL, (data: Object) => {
      // header height - header height scrolled = 77
      if (!data.scrolled || data.scrollTop < 77) {
        pEl.classList.remove(this.scrolledClass);
      } else {
        pEl.classList.add(this.scrolledClass);
      }

      // TODO: We need to know the header height beforehand to make this reposition more smoothly
      setTimeout(() => {
        window.notification.config.offset = window.store.headerHeight;
        window.notification.repositionAll();
      }, this.scrollTransitionInMilliseconds);
    });

    this.addListener(Notifications.FOCUSED_ON_SEARCH, () => {
      this.notify(Notifications.DISALLOW_SCROLLBAR);
      pEl.classList.add(this.searchClass);
      pEl.classList.remove(this.scrolledClass);

      if (!isLargeScreen()) {
        new Scroll().scroll();
      }
    });

    this.addListener(Notifications.HIDE_SEARCH_SUGGESTIONS, () => {
      this.notify(Notifications.ALLOW_SCROLLBAR);
      pEl.classList.remove(this.searchClass);
    });
  }
}
